<template>
  <section class="c-step c-step--welcome py-4 py-lg-5 overflow-hidden">
    <b-modal
      id="modalProfile"
      centered
      hide-footer
      hide-header
      hide-actions
      no-close-on-backdrop>
      <section class="c-modal-lection c-modal-lection--tour">
        <div class="c-modal-lection__dialog">
          <section class="p-3 p-lg-4">
            <h3 class="fs-21 w-bold mb-5 text-center">
              Ingresa todos tus datos correctos para incluirlos en todos tus certificados
            </h3>
            <form class="c-form c-form--ghost mb-4">
              <div class="mb-4">
                <p class="c-form__label mb-1">Nombres completos</p>
                <div class="mb-3">
                  <input
                    v-model="user.firstName.value"
                    type="text"
                    class="c-form__input w-100"
                    :class="{'is-invalid' : isWrongUserField(user.firstName)}"
                    placeholder="Nombres"/>
                  <span v-if="isWrongUserField(user.firstName)" class="c-form__error">
                    Nombres incorrectos
                  </span>
                </div>
                <div>
                  <input
                    v-model="user.lastName.value"
                    type="text"
                    class="c-form__input w-100"
                    :class="{'is-invalid' : isWrongUserField(user.lastName)}"
                    placeholder="Apellidos"/>
                  <span v-if="isWrongUserField(user.lastName)" class="c-form__error">
                    Apellidos incorrectos
                  </span>
                </div>
              </div>
              <div class="mb-4">
                <p class="c-form__label mb-1">Fecha de nacimiento</p>
                <div>
                  <input
                    v-model="user.birthDate.value"
                    type="date"
                    class="c-form__input w-100"
                    :class="{'is-invalid' : isWrongUserField(user.birthDate)}"/>
                  <span v-if="isWrongUserField(user.birthDate)" class="c-form__error">
                    Fecha de nacimiento incorrecta
                  </span>
                </div>
              </div>
              <label class="c-form__checkbox-inline">
                <input v-model="user.isConfirmed" type="checkbox" class="d-none"/>
                <div class="c-square">
                  <span></span>
                </div>
                <span>
                  Confirmo que mis nombres y apellidos están correctamente escritos y
                  <strong>entiendo que no podré volver a modificarlos.</strong>
                </span>
              </label>
              <span
                v-if="isWrongUserField(user.isConfirmed, 'single')"
                class="c-form__error mt-3 d-block"
              >
                Debe confirmar sus datos
              </span>
            </form>
            <button
              @click="saveUser"
              :disabled="isLoadingUser"
              class="c-button c-button--primary w-100"
              :class="{loading : isLoadingUser}">
              {{ (isLoadingUser) ? 'Enviando datos...' : 'Confirmar datos y enviar' }}
              <img
                class="c-button__spinner"
                src="../../assets/images/animations/spinner-white.png" alt="loading"
              />
            </button>
          </section>
        </div>
      </section>
    </b-modal>

    <div class="container">
      <div class="row justify-content-center">
        <div class="col col-12 col-md-9 col-lg-12 col-xl-10">
          <section class="c-welcome bg-white br--small">
            <div class="row">
              <div class="col col-12 col-lg-6 mb-lg-0">
                <div class="c-welcome__presentation bg-white br--small h-100">
                  <div class="c-welcome__banner d-flex justify-content-center align-items-center">
                    <h1 class="text-center white fs-45 w-black">¡Bienvenido!</h1>
                    <span class="c-buble c-buble--left"></span>
                    <span class="c-buble c-buble--right"></span>
                  </div>
                  <div class="d-flex flex-column justify-content-between p-3 p-md-4 flex-grow-1">
                    <div class="c-course-detail position-relative">
                      <figure class="c-course-detail__thumbnail">
                        <img
                          class="w-100 h-100 of--cover" :src="course.image" :alt="course.title"
                        />
                      </figure>
                      <div class="c-sticker position-absolute">
                        <i class="c-icon iconf-medal d-flex align-items-center"></i>
                      </div>
                      <span class="c-course-detail__sticker c-course-detail__sticker--book">
                        <img
                          class="c-icon of--contain"
                          src="../../assets/images/icons/exam/book.svg" alt=""
                        />
                      </span>
                      <span class="c-course-detail__sticker c-course-detail__sticker--ruler">
                        <img class="c-icon of--contain"
                        src="../../assets/images/icons/exam/ruler.svg" alt=""
                      />
                      </span>
                      <span class="c-course-detail__sticker c-course-detail__sticker--pen">
                        <img
                          class="c-icon of--contain"
                          src="../../assets/images/icons/exam/pen.svg" alt=""
                        />
                      </span>
                    </div>
                    <p class="mt-3 mb-0 text-center">
                      Es hora de demostrar lo que aprendiste en:
                      <span class="w-bold darks">{{ course.title }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="col col-12 col-lg-6">
                <div class="c-welcome__details p-3 p-md-4">
                  <div id="welcome-slider" class="swiper-container">
                    <div class="swiper-wrapper">
                      <div class="swiper-slide">
                        <div
                          class="c-explanation d-flex flex-column align-items-center text-center">
                          <figure class="c-explanation__vector mb-3">
                            <img
                              class="w-100 of--contain"
                              src="../../assets/images/exam/welcome.png" alt=""
                            />
                          </figure>
                          <h2 class="w-bold fs-21 darks mb-3">Recuerda que</h2>
                          <p class="mb-4">
                            Para superar este examen deberas responder
                            <span class="w-sbold">
                              {{ settings.selected_questions }} preguntas
                            </span> en
                            <span class="w-sbold">{{ examTime }} minutos</span>.
                            Si fallas, en 6 horas lo podrás volver a intentar. No te preocupes.
                            Puedes intentar pasar el examen tantas veces como quieras.
                          </p>
                          <button
                            class="c-button c-button--primary w-100"
                            :class="{loading : isLoadingExam}"
                            :disabled="isLoadingExam"
                            @click="profileCompleted ? startExam() : openProfileModal()">
                            {{(isLoadingExam) ? 'Creando examen...' : 'Empezar'}}
                            <img
                              class="c-button__spinner"
                              src="../../assets/images/animations/spinner-white.png" alt="loading"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */
import Swiper from 'swiper';

import {validateText, validateSelect} from '../../libs/forms';

export default {
  data() {
    return {
      isLoadingExam: false,
      isLoadingUser: false,
      welcomeSlider: null,

      user: {
        try: false,
        isConfirmed: false,
        firstName: {
          value: '',
          isValid: false,
          pattern: '^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,._\'-]+$',
        },
        lastName: {
          value: '',
          isValid: false,
          pattern: '^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,._\'-]+$',
        },
        birthDate: {
          value: '1990-12-31',
          isValid: true,
        },
      },
    }
  },
  props: ['userData', 'step', 'exam', 'course', 'profileCompleted', 'settings'],
  mounted() {
    this.initWelcomeSlider();
  },
  computed: {
    examTime: function() {
      return this.settings.question_time * this.settings.selected_questions;
    },
  },
  watch: {
    'user.firstName.value': function(){
      this.user.firstName.isValid = this.validateText(this.user.firstName);
    },
    'user.lastName.value': function(){
      this.user.lastName.isValid = this.validateText(this.user.lastName);
    },
    'user.birthDate.value': function(){
      this.validateSelect(this.user.birthDate)
    },
  },
  methods: {
    validateText,
    validateSelect,
    initWelcomeSlider: function() {
      window.setTimeout(()=>{
        this.welcomeSlider = new Swiper('#welcome-slider', {
          allowTouchMove: false,
          speed: 900,
          loop: false,
          spaceBetween: 10,
        });
      }, 1000)
    },
    openProfileModal: function() {
      this.$bvModal.show('modalProfile');
    },
    isWrongUserField: function(field, type = 'multiple') {
      return this.user.try && ((type == 'multiple') ? !field.isValid : !field);
    },
    startExam: function() {
      this.isLoadingExam = true;

      const url = `${window.arcux.site}/api/v1/users/${this.userData.id}/solved-exams/`;

      fetch(url,{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${window.arcux.token}`,
        },
        body: JSON.stringify({
          examId: this.$route.params.exam_id,
          courseId: this.$route.params.course_id,
        }),
      })
      .then(res => {
        if (res.status == 201 || res.status < 300) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then(data => {
        this.$emit('update:exam', data.data);

        this.nextStep();
      })
      .catch(err => {
        throw err;
      }).finally(() => {
        this.isLoadingExam = false;
      });
    },
    saveUser: function() {
      this.user.try = true;

      if (
        this.user.firstName.isValid &&
        this.user.lastName.isValid &&
        this.user.birthDate.isValid &&
        this.user.isConfirmed
      ) {
        this.isLoadingUser = true;

        const url = `${window.arcux.site}/api/v1/users/${this.userData.id}/profile/complete/`;

        fetch(url,{
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${window.arcux.token}`,
          },
          body: JSON.stringify({
            firstName: this.user.firstName.value,
            lastName: this.user.lastName.value,
            dateBorn: this.user.birthDate.value,
          }),
        })
        .then(res => {
          if (res.status == 201 || res.status < 300) {
            return res.json();
          } else {
            throw res;
          }
        })
        .then(data => {
          this.$bvModal.hide('modalProfile');

          this.startExam();
        })
        .catch(err => {
          throw err;
        }).finally(() => {
          this.isLoadingUser = false;
        });
      }
    },
    nextStep: function() {
      this.$emit('update:step', 2);
    },
  },
}
</script>
